export default defineAppConfig({
  brand: {
    name: 'amma - Prescrições',
    shortName: 'amma',
    subtitle: 'Sistema de Prescrição Farmacêutica',
  }
})
